import { render } from "./CodeIcon.vue?vue&type=template&id=2699e788&scoped=true"
import script from "./CodeIcon.vue?vue&type=script&lang=js"
export * from "./CodeIcon.vue?vue&type=script&lang=js"

import "./CodeIcon.vue?vue&type=style&index=0&id=2699e788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2699e788"]])

export default __exports__